/*
 * @Author: your name
 * @Date: 2020-11-17 16:08:15
 * @LastEditTime: 2021-03-09 13:29:09
 * @LastEditors: zhangcx33595
 * @Description: In User Settings Edit
 * @FilePath: \openplat-web\src\gtn\api\login.js
 */
import fetch from "./httpFetch.js";
import Cookies from "js-cookie";
import axios from "axios";
export function reLogin(username, password) {
  let data = {
    username,
    password
  };
  return fetch.get("/openplat-auth-server/v/reLogin", data);
}
export function login(data) {
  return fetch.post("/openplat-auth-server/v/login", data);
}
export function isLogin() {
  return fetch.post("/openplat-auth-server/v/isLogin", {});
}
// 更新用户账号
export function updateUserByHsAccount(data) {
  return fetch.post('/openplat-user-server/v/updateUserByHsAccount', data)
}
//获取图形验证码
export function CheckCode() {
  return fetch.get("/openplat-auth-server/v/img/get_check_code");
}
//账号密码登录
export function accountLogin(data) {
  return fetch.post("/openplat-auth-server/v/account_login", data, {
    errorHandler: true
  });
}
//获取短信验证码
export function smsCheckCode(data) {
  return fetch.get("/openplat-auth-server/v/sms/get_check_code" + data, {
    errorHandler: true
  });
}

// 获取短信验证码
export function get_check_code(phone, type = 1) {
	return fetch.get(`/openplat-auth-server/v/sms/get_check_code?phone=${phone}&captcha_sms_type=${type}`, {
    errorHandler: true
  })
}

//短信验证码登录
export function smsLogin(data) {
  return fetch.post("/openplat-auth-server/v/sms_login", data, {
    errorHandler: true
  });
}
//pc获取微信登录二维码js对象
export function wechatQrCode(data) {
  return fetch.get("/openplat-auth-server/v/wechat_qr_code" + data);
}
//微信绑定手机号
export function wechatBindPhone(data) {
  return fetch.post("/openplat-auth-server/v/wechat_bind_phone", data, {
    errorHandler: true
  });
}
//忘记密码-验证账户
export function validateAccount(data) {
  return fetch.post("/openplat-auth-server/v/validate_account", data, {
    errorHandler: true
  });
}
//忘记密码-重置密码
export function resetPassword(data) {
  return fetch.post("/openplat-auth-server/v/reset_password", data, {
    errorHandler: true
  });
}
//手机是否注册
export function isRegister(data) {
  return fetch.get("/openplat-auth-server/v/is_register" + data);
}
//注册
export function register(data) {
  return fetch.post("/openplat-auth-server/v/register", data, {
    errorHandler: true
  });
}

export function isLoginJson(data) {
  return fetch.post("/cloud/open/user/is_login.json", data, {
    errorHandler: true
  });
}
//判断用户中心是否登录
export function CASLoginAPI() {
  // ;
  return axios.get(
    "/iuc/api/is_login",{ crossDomain: true,withCredentials: true }
  ).then((res)=>{
    return res.data
  })
  // const instance = axios.create({
  //   baseURL: window.LOCAL_CONFIG.userCenter,
  //   timeout: 1000,
  //   withCredentials: true,
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  // });
  // return (
  //   instance.post('/iuccasserver/CASLoginAPI.do')
  // )
}



function convertTreeData(rows, attributes) {
  var keyNodes = {},
    parentKeyNodes = {};
  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    row.id = row[attributes.id];
    row.parentId = row[attributes.parentId];
    row.title = row[attributes.title] ? row[attributes.title] : null;
    row.url = row[attributes.url] ? row[attributes.url] : null;
    row.icon = row[attributes.icon] ? row[attributes.url] : null;
    row.children = [];

    keyNodes[row.id] = row;

    if (parentKeyNodes[row.parentId]) {
      parentKeyNodes[row.parentId].push(row);
    } else {
      parentKeyNodes[row.parentId] = [row];
    }

    var children = parentKeyNodes[row.id];
    if (children) {
      row.children = children;
    }

    var pNode = keyNodes[row.parentId];
    if (pNode) {
      pNode.children.push(row);
    }
  }
  return parentKeyNodes[attributes.rootParentId];
}

export function getMenuList(token) {
  // return fetch.get("/getMenuList")
  return new Promise((resolve, reject) => {
    fetch.get("/getMenuListSimp").then(res => {
      if (res && res.data.length > 0) {
        const data = convertTreeData(res.data, {
          id: "menu_id",
          title: "menu_name",
          parentId: "menu_parent_id",
          icon: "menu_icon",
          url: "menu_url",
          rootParentId: "BIZFRAME"
        });
        resolve({ data: data });
      }
    });
  });
}

export function logout() {
  return fetch.post("/openplat-auth-server/v/logout");
}

export function loginExit() {
  axios({
    url: "/cloud/open/user/loginExit.json",
    method: "post",
    headers: {
      "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
    },
    withCredentials: true
  }).then(res => {
    // ;
    console.log(res);
  });
}

/**
 * 描述 对html网页登录的兼容
 * @date 2021-12-17
 * @param { userBehavior: String } userBehavior:登录之后的回调地址
 * @returns {any}
 */
export function setBehavior(params) {
  return fetch({
    url: '/cloud/open/user/setUserBehavior.json',
    method: 'get',
    params,
  })
}



// WEBPACK FOOTER //
// ./src/gtn/api/login.js